import { createRouter, createWebHistory } from 'vue-router'

import Layout from '@/layout/index.vue'

// 公共路由
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login.vue'),
    hidden: true,
  },
  {
    path: '',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        component: () => import('@/views/index.vue'),
        name: 'Index',
        meta: { title: '首页', icon: 'home', affix: true },
      },
      // {
      //   path: '/accidentManagement',
      //   name: 'accidentManagement',
      //   meta: { title: '事故管理', icon: 'accident', affix: true },
      //   children: [
      //     {
      //       path: '/accidentManagement/index',
      //       component: () => import('@/views/accidentInformation/index.vue'),
      //       name: 'accidentInformationIndex',
      //       meta: { title: '事故信息', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/accidentInformation/list',
      //       component: () => import('@/views/accidentInformation/list.vue'),
      //       name: 'accidentInformationList',
      //       meta: { title: '事故列表', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/accidentInformation/detail/:id',
      //       component: () => import('@/views/accidentInformation/detail.vue'),
      //       name: 'accidentInformationDetail',
      //       meta: { title: '事故详情', icon: 'phone', affix: true },
      //       show: false, // 不在菜单中显示
      //     },
      //     {
      //       path: '/accidentInformation/authPolice',
      //       component: () => import('@/views/accidentInformation/authPolice.vue'),
      //       name: 'accidentInformationAuthPolice',
      //       meta: { title: '认证交警', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/accidentInformation/authPoliceDetail/:id/:type',
      //       component: () => import('@/views/accidentInformation/components/authPoliceDetail.vue'),
      //       name: 'accidentInformationAuthPoliceDetail',
      //       meta: { title: '交警详情', icon: 'phone', affix: true },
      //       show: false, // 不在菜单中显示
      //     },
      //     {
      //       path: '/accidentInformation/referralCode',
      //       component: () => import('@/views/accidentInformation/referralCode.vue'),
      //       name: 'referralCode',
      //       meta: { title: '推荐码', icon: 'phone', affix: true },
      //     },
      //   ],
      // },
      // {
      //   path: '/deviceManagement',
      //   name: 'deviceManagement',
      //   meta: { title: '设备管理', icon: 'equipment', affix: true },
      //   children: [
      //     {
      //       path: '/deviceManagement/aiTripod/1',
      //       component: () => import('@/views/deviceManagement/aiTripod.vue'),
      //       name: 'deviceManagementAiTripod',
      //       meta: { title: 'AI三脚架', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/deviceManagement/soldTripod/1',
      //       component: () => import('@/views/deviceManagement/soldTripod.vue'),
      //       name: 'deviceManagementSoldTripod',
      //       meta: { title: '已出售三脚架', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/deviceManagement/aiTripodDetail/:id',
      //       component: () => import('@/views/deviceManagement/aiTripodDetail.vue'),
      //       name: 'deviceManagementAiTripodDetail',
      //       meta: { title: '三角架详情', icon: 'phone', affix: true },
      //       show: false,
      //     },
      //   ],
      // },
      // {
      //   path: '/agreementManagement',
      //   name: 'agreementManagement',
      //   meta: { title: '协议管理', icon: 'agreement', affix: true },
      //   children: [
      //     {
      //       path: '/agreementManagement/niuniuEscort',
      //       component: () => import('@/views/agreementManagement/niuniuEscort.vue'),
      //       name: 'agreementManagementNiuniuEscort',
      //       meta: { title: '牛牛护驾', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/agreementManagement/wechatMiniProgram',
      //       component: () => import('@/views/agreementManagement/wechatMiniProgram.vue'),
      //       name: 'agreementManagementWechatMiniProgram',
      //       meta: { title: '微信小程序', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/agreementManagement/merchantAdmin',
      //       component: () => import('@/views/agreementManagement/merchantAdmin.vue'),
      //       name: 'agreementManagementMerchantAdmin',
      //       meta: { title: '商户后台', icon: 'phone', affix: true },
      //     },
      //   ],
      // },
      // {
      //   path: '/niuniuHujia',
      //   name: 'niuniuHujia',
      //   meta: { title: '牛牛护驾', icon: 'numen', affix: true },
      //   redirect: '/niuniuHujia/banner',
      //   children: [
      //     {
      //       path: '/niuniuHujia/banner',
      //       component: () => import('@/views/niuniuHujia/banner.vue'),
      //       name: 'NiuniuHujiaBanner',
      //       meta: { title: 'Banner管理', icon: 'image', affix: true },
      //     },
      //     {
      //       path: '/niuniuHujia/news',
      //       component: () => import('@/views/niuniuHujia/news.vue'),
      //       name: 'NiuniuHujiaNews',
      //       meta: { title: '资讯管理', icon: 'document', affix: true },
      //     },
      //     {
      //       path: 'articleList/addArticle',
      //       component: () => import('@/views/niuniuHujia/components/add.vue'),
      //       name: 'articleList-addArticle',
      //       meta: {
      //         title: '发布资讯',
      //         icon: 'document',
      //         affix: true,
      //         hidden: true,
      //         isMenu: false,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: 'articleList/evaluation',
      //       component: () => import('@/views/niuniuHujia/components/evaluation.vue'),
      //       name: 'articleList-evaluation',
      //       meta: {
      //         title: '评价管理',
      //         icon: 'document',
      //         affix: true,
      //         hidden: true,
      //         isMenu: false,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/niuniuHujia/topic',
      //       component: () => import('@/views/niuniuHujia/topic.vue'),
      //       name: 'NiuniuHujiaTopic',
      //       meta: { title: '话题管理', icon: 'chat-dot-square', affix: true },
      //     },
      //     {
      //       path: '/niuniuHujia/activity',
      //       component: () => import('@/views/niuniuHujia/activity.vue'),
      //       name: 'NiuniuHujiaActivity',
      //       meta: { title: '活动管理', icon: 'calendar', affix: true },
      //     },
      //     {
      //       path: '/niuniuHujia/activity/add',
      //       component: () => import('@/views/niuniuHujia/components/AddActivity.vue'),
      //       name: 'NiuniuHujiaActivityAdd',
      //       meta: {
      //         title: '新增活动',
      //         icon: 'calendar',
      //         affix: false,
      //         hidden: true,
      //       },
      //       show: false,
      //     },
      //   ],
      // },
      // // 产品推广
      // {
      //   path: '/productPromotion',
      //   name: 'productPromotion',
      //   meta: { title: '产品推广', icon: 'promotion', affix: true },
      //   redirect: '/productPromotion/data',
      //   children: [
      //     {
      //       path: '/productPromotion/data',
      //       component: () => import('@/views/productPromotion/promotionData.vue'),
      //       name: 'productPromotion-data',
      //       meta: {
      //         title: '数据中心',
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/productPromotion/list',
      //       component: () => import('@/views/productPromotion/promotionList.vue'),
      //       name: 'productPromotion-list',
      //       meta: {
      //         title: '推广人员',
      //         isMenu: true,
      //       },
      //     },
      //     // {
      //     //   path: 'applicationReview',
      //     //   component: () => import('@/views/productPromotion/applicationReview.vue'),
      //     //   name: 'productPromotion-applicationReview',
      //     //   meta: {
      //     //     title: '申请审核',
      //     //     isMenu: true,
      //     //   },
      //     // show: false,
      //     // props: true,
      //     // },
      //     {
      //       path: '/productPromotion/rules',
      //       component: () => import('@/views/productPromotion/promotionRules.vue'),
      //       name: 'productPromotion-rules',
      //       meta: {
      //         title: '规则说明',
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/productPromotion/list/info',
      //       component: () => import('@/views/productPromotion/components/detailsInfo.vue'),
      //       name: 'productPromotionList-info',
      //       meta: {
      //         title: '推广详情信息',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/productPromotion/list/details',
      //       component: () => import('@/views/productPromotion/components/detailsPromotion.vue'),
      //       name: 'productPromotionList-details',
      //       meta: {
      //         title: '推广详情',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/productPromotion/list/settlement',
      //       component: () => import('@/views/productPromotion/components/detailsPayment.vue'),
      //       name: 'productPromotionList-settlement',
      //       meta: {
      //         title: '结算详情',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/productPromotion/rules/add',
      //       component: () => import('@/views/productPromotion/components/rulesAdd.vue'),
      //       name: 'rulesAdd-add',
      //       meta: {
      //         title: '新增规则',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/productPromotion/rules/details',
      //       component: () => import('@/views/productPromotion/components/rulesDetail.vue'),
      //       name: 'rulesAdd-details',
      //       meta: {
      //         title: '规则详情',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,

      //     },
      //     {
      //       path: '/productPromotion/settlement/detail',
      //       component: () => import('@/views/productPromotion/components/settlementDetails.vue'),
      //       name: 'settlement-detail',
      //       meta: {
      //         title: '结算单详情',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //   ],
      // },
      // // 用户管理
      // {
      //   path: '/userManagement',
      //   name: 'userManagement',
      //   meta: { title: '用户管理', affix: true },
      //   children: [
      //     {
      //       path: '/userManagement',
      //       component: () => import('@/views/userManagement/index.vue'),
      //       name: 'userManagementList',
      //       meta: { title: '用户列表', affix: true, },
      //     },
      //     {
      //       path: '/userManagement/details',
      //       component: () => import('@/views/userManagement/details.vue'),
      //       name: 'userManagementDetails',
      //       meta: { title: '用户详情', affix: true, hidden: true },
      //       show: false,
      //     },
      //   ],
      // },

      // {
      //   path: '/productManagement',
      //   name: 'productManagement',
      //   meta: { title: '商品管理', icon: 'goods', affix: true },
      //   children: [
      //     {
      //       path: '/productManagement/publishProduct',
      //       component: () => import('@/views/productManagement/publishProduct.vue'),
      //       name: 'publishProduct',
      //       meta: { title: '发布商品', affix: true },
      //     },
      //     {
      //       path: '/productManagement',
      //       component: () => import('@/views/productManagement/index.vue'),
      //       name: 'productManagementList',
      //       meta: { title: '商品列表', affix: true },
      //     },
      //     {
      //       path: '/productManagement/evaluation',
      //       component: () => import('@/views/productManagement/evaluation.vue'),
      //       name: 'productManagementEvaluation',
      //       meta: {
      //         title: '评价管理',
      //         affix: true,
      //         hidden: true,
      //         isMenu: false,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //   ],
      // },
      // // 团购管理
      // {
      //   path: '/groupBuyingManagement',
      //   name: 'groupBuyingManagement',
      //   meta: { title: '团购管理', icon: 'shopping', affix: true },
      //   children: [
      //     {
      //       path: '/groupBuyingManagement/groupPurchaseReview',
      //       component: () => import('@/views/groupBuyingManagement/groupPurchaseReview.vue'),
      //       name: 'groupPurchaseReview',
      //       meta: { title: '团购审核', affix: true },
      //     },
      //     {
      //       path: '/groupBuyingManagement/groupPurchaseList',
      //       component: () => import('@/views/groupBuyingManagement/groupPurchaseList.vue'),
      //       name: 'groupPurchaseList',
      //       meta: { title: '团购列表', affix: true },
      //     },
      //     {
      //       path: '/groupBuyingManagement/storeOrderList',
      //       component: () => import('@/views/groupBuyingManagement/storeOrderList.vue'),
      //       name: 'storeOrderList',
      //       meta: { title: '门店订单', affix: true },
      //     },
      //     {
      //       path: '/groupBuyingManagement/groupPurchaseOrderList',
      //       component: () => import('@/views/groupBuyingManagement/groupPurchaseOrderList.vue'),
      //       name: 'groupPurchaseOrderList',
      //       meta: { title: '团购订单', affix: true },
      //     },
      //     {
      //       path: '/groupBuyingManagement/rescueOrderList',
      //       component: () => import('@/views/groupBuyingManagement/rescueOrderList.vue'),
      //       name: 'rescueOrderList',
      //       meta: { title: '救援订单', affix: true },
      //     },
      //     {
      //       path: '/groupBuyingManagement/groupPurchaseDetails',
      //       component: () => import('@/views/groupBuyingManagement/groupPurchaseDetails.vue'),
      //       name: 'groupPurchaseDetails',
      //       meta: { title: '团购详情', affix: true },
      //       show: false,
      //     },
      //     {
      //       path: '/groupBuyingManagement/repairOrderPreview',
      //       component: () => import('@/views/groupBuyingManagement/RepairOrderPreview.vue'),
      //       name: 'repairOrderPreview',
      //       meta: { title: '维修单预览', affix: true },
      //       show: false,
      //     },
      //   ]
      // },
      // // 商户管理
      // {
      //   path: '/merchantManagement',
      //   name: 'merchantManagement',
      //   meta: { title: '商户管理', icon: 'merchant', affix: true },
      //   redirect: '/merchantManagement/list',
      //   children: [
      //     {
      //       path: '/merchantManagement/list',
      //       component: () => import('@/views/merchantManagement/list.vue'),
      //       name: 'merchantManagement-list',
      //       meta: {
      //         title: '商户列表',
      //         icon: 'phone',
      //         affix: true,
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/merchantManagement/check',
      //       component: () => import('@/views/merchantManagement/check.vue'),
      //       name: 'merchantManagement-check',
      //       meta: {
      //         title: '商户审核',
      //         icon: 'phone',
      //         affix: true,
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/merchantManagement/withdrawal',
      //       component: () => import('@/views/merchantManagement/withdrawal.vue'),
      //       name: 'merchantManagement-withdrawal',
      //       meta: {
      //         title: '商户提现',
      //         icon: 'phone',
      //         affix: true,
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/merchantManagement/report',
      //       component: () => import('@/views/merchantManagement/report.vue'),
      //       name: 'merchantManagement-report',
      //       meta: {
      //         title: '商户举报',
      //         icon: 'phone',
      //         affix: true,
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/merchantManagement/appeal',
      //       component: () => import('@/views/merchantManagement/appeal.vue'),
      //       name: 'merchantManagement-appeal',
      //       meta: {
      //         title: '评价申诉',
      //         icon: 'phone',
      //         affix: true,
      //         isMenu: true,
      //       },
      //     },
      //     {
      //       path: '/merchantManagement/details',
      //       component: () => import('@/views/merchantManagement/components/details.vue'),
      //       name: 'merchantManagement-details',
      //       meta: {
      //         title: '商户详情',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/merchantManagement/operation',
      //       component: () => import('@/views/merchantManagement/components/operation.vue'),
      //       name: 'merchantManagement-operation',
      //       meta: {
      //         title: '运营情况',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //     {
      //       path: '/merchantManagement/appealDetail',
      //       component: () => import('@/views/merchantManagement/components/appealDetail.vue'),
      //       name: 'merchantManagement-appealDetail',
      //       meta: {
      //         title: '评价申诉详情',
      //         isMenu: false,
      //         hidden: true,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //   ],
      // },

      // {
      //   path: '/communityManagement',
      //   name: '社区管理',
      //   meta: { title: '社区管理', icon: 'community', affix: true },
      //   children: [
      //     {
      //       path: '/communityManagement/pendingReview',
      //       component: () => import('@/views/communityManagement/pendingReview.vue'),
      //       name: '待审核',
      //       meta: { title: '待审核', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/communityManagement/report',
      //       component: () => import('@/views/communityManagement/report.vue'),
      //       name: '举报',
      //       meta: { title: '举报', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/communityManagement/undercarriage',
      //       component: () => import('@/views/communityManagement/undercarriage.vue'),
      //       name: '已下架',
      //       meta: { title: '已下架', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/communityManagement/release',
      //       component: () => import('@/views/communityManagement/release.vue'),
      //       name: '已发布',
      //       meta: { title: '已发布', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/contentManagement/index',
      //       component: () => import('@/views/contentManagement/index.vue'),
      //       name: '内容管理',
      //       meta: {
      //         title: '内容管理',
      //         icon: 'document',
      //         affix: true,
      //         hidden: true,
      //         isMenu: false,
      //       },
      //       props: true,
      //     },
      //   ],
      // },
      // {
      //   path: '/insurance/index',
      //   component: () => import('@/views/insurance/index.vue'),
      //   name: '保险管理',
      //   meta: { title: '保险管理', icon: 'phone', affix: true },
      // },

      //         isMenu: false,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //   ]
      // },
      // {
      //   path: '/communityManagement',
      //   name: '社区管理',
      //   meta: { title: '社区管理', icon: 'community', affix: true },
      //   children: [
      //     {
      //       path: '/communityManagement/pendingReview',
      //       component: () => import('@/views/communityManagement/pendingReview.vue'),
      //       name: '待审核',
      //       meta: { title: '待审核', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/communityManagement/report',
      //       component: () => import('@/views/communityManagement/report.vue'),
      //       name: '举报',
      //       meta: { title: '举报', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/communityManagement/undercarriage',
      //       component: () => import('@/views/communityManagement/undercarriage.vue'),
      //       name: '已下架',
      //       meta: { title: '已下架', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/communityManagement/release',
      //       component: () => import('@/views/communityManagement/release.vue'),
      //       name: '已发布',
      //       meta: { title: '已发布', icon: 'phone', affix: true },
      //     },
      //     {
      //       path: '/contentManagement/index',
      //       component: () => import('@/views/contentManagement/index.vue'),
      //       name: '内容管理',
      //       meta: {
      //         title: '内容管理',
      //         icon: 'document',
      //         affix: true,
      //         hidden: true,
      //         isMenu: false,
      //       },
      //       show: false,
      //       props: true,
      //     },
      //   ],
      // },
      // {
      //   path: '/insurance/index',
      //   component: () => import('@/views/insurance/index.vue'),
      //   name: '保险管理',
      //   meta: { title: '保险管理', icon: 'community', affix: true },
      // },
      // {
      //   path: '/messageManagement',
      //   name: '消息管理',
      //   meta: { title: '消息管理', icon: 'message', affix: true },
      //   children: [
      //     {
      //       path: '/messageManagement/notification',
      //       component: () => import('@/views/messageManagement/notification.vue'),
      //       name: 'messageManagementNotificationList',
      //       meta: { title: '消息通知', affix: true },
      //     },
      //     {
      //       path: '/messageManagement/push',
      //       component: () => import('@/views/messageManagement/push.vue'),
      //       name: 'messageManagementPushList',
      //       meta: { title: '推送记录', affix: true },
      //     },
      //   ]
      // },
      // // 系统管理
      // {
      //   path: '/system',
      //   name: 'system',
      //   meta: { title: '系统管理', icon: 'system', affix: true },
      //   children: [
      //     {
      //       path: '/system/menu',
      //       component: () => import('@/views/system/menu.vue'),
      //       name: 'systemMenu',
      //       meta: { title: '菜单管理', affix: true },
      //     },
      //     {
      //       path: '/system/role',
      //       component: () => import('@/views/system/role.vue'),
      //       name: 'systemRole',
      //       meta: { title: '角色管理', affix: true },
      //     },
      //     {
      //       path: '/system/user',
      //       component: () => import('@/views/system/user.vue'),
      //       name: 'systemUser',
      //       meta: { title: '用户管理', affix: true },
      //     },
      //   ],
      // },
      // 版本管理
      // {
      //   path: '/system/version',
      //   component: () => import('@/views/versionManagement/version.vue'),
      //   name: '版本管理',
      //   meta: { title: '版本管理', icon: 'community', affix: true },
      // },
    ],
  },
  /** 404页面 */
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404.vue'),
  },
  /** 401页面 */
  {
    path: '/403',
    component: () => import('@/views/error/403.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
})

/**
 * 动态加载路由
 * 将后端返回的路由配置转换为 Vue Router 可识别的路由对象并添加到路由表
 * @param {Array} routes - 后端返回的路由配置数组
 */
export const loadDynamicRoutes = (routes) => {
  /**
   * Layout 组件（异步加载）
   */
  const Layout = () => import('@/layout/index.vue')

  /**
   * 预加载所有视图组件
   * 使用 import.meta.glob 静态分析所有 .vue 文件
   */
  const viewModules = import.meta.glob('../views/**/*.vue')

  /**
   * 递归添加路由
   * @param {Array} routeList - 路由列表
   * @param {string} parentName - 父路由名称（用于建立父子关系）
   */
  const addRoutes = (routeList, parentName = '') => {
    routeList.forEach((route) => {
      /**
       * 构建路由对象
       */
      const routerItem = {
        path: route.path,
        name: route.name || route.path.replace(/\//g, '-'),
        hidden: route.hidden || false,
        redirect: route.redirect === 'noRedirect' ? undefined : route.redirect,
        meta: route.meta || {},
        alwaysShow: route.alwaysShow || false,
      }

      /**
       * 处理组件映射
       */
      if (route.component) {
        if (route.component === 'Layout') {
          routerItem.component = Layout
        } else {
          // 处理组件路径，移除前导斜杠
          const componentPath = route.component.startsWith('/')
            ? route.component.slice(1)
            : route.component
          // 确保路径以 .vue 结尾
          const normalizedPath = componentPath.endsWith('.vue')
            ? componentPath
            : `${componentPath}.vue`
          const importPath = `../views/${normalizedPath}`

          // 使用预加载的组件模块
          if (viewModules[importPath]) {
            routerItem.component = viewModules[importPath]
          } else {
            console.error(`组件路径 ${importPath} 不存在`)
            routerItem.component = () => import('@/views/index.vue')
          }
        }
      }

      try {
        // 根据是否有父路由，决定添加方式
        if (parentName) {
          router.addRoute(parentName, routerItem)
        } else {
          // 一级路由且组件不是 Layout，自动包装在 Layout 下
          if (route.component !== 'Layout' && route.component) {
            // 从路径中提取父路径，如 /insurance/index -> /insurance
            const pathSegments = route.path.split('/').filter(Boolean)
            const parentPath = '/' + (pathSegments[0] || '')
            const parentName = route.name
              ? route.name.split('/')[0]
              : pathSegments[0] || route.path.replace(/\//g, '-')

            const parentRoute = {
              path: parentPath,
              name: parentName,
              component: Layout,
              redirect: route.path,
              meta: {},
            }
            router.addRoute(parentRoute)
            // 添加子路由，使用相对路径
            routerItem.path = pathSegments.slice(1).join('/') || ''
            router.addRoute(parentName, routerItem)
          } else {
            router.addRoute(routerItem)
          }
        }

        // 递归处理子路由
        if (route.children && route.children.length > 0) {
          addRoutes(route.children, routerItem.name)
        }
      } catch (error) {
        console.error('添加路由失败:', error)
      }
    })
  }

  addRoutes(routes)
}

/**
 * 重置路由
 * 清除所有动态添加的路由，恢复到初始状态
 */
export const resetRouter = () => {
  router.options.routes = constantRoutes
  const newRouter = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: constantRoutes,
  })
  Object.assign(router, newRouter)
}

/**
 * 路由加载锁
 * 防止路由加载过程中被重复触发
 * @type {boolean}
 */
let isLoadingRoutes = false

/**
 * 设置路由守卫
 * 在每次导航前检查动态路由是否已加载，若未加载则先加载再导航
 */
export const setupRouteGuard = () => {
  router.beforeEach(async (to, from, next) => {
    // 登录页面直接放行
    if (to.path === '/login') {
      next()
      return
    }

    // 动态导入 useRouteStore，避免循环依赖
    const { useRouteStore } = await import('@/stores/model/useRouteStore')
    const routeStore = useRouteStore()

    // 检查目标路由是否存在
    const hasRoute = router.hasRoute(to.name) || router.getRoutes().some((r) => r.path === to.path)

    // 如果路由未加载，或者路由已加载但目标路由不存在（可能是刷新导致动态路由丢失），则重新加载
    if ((!routeStore.isRoutesLoaded || !hasRoute) && !isLoadingRoutes) {
      isLoadingRoutes = true
      try {
        // 从后端加载路由配置
        const routes = await routeStore.loadRoutes()
        // 添加动态路由
        loadDynamicRoutes(routes)
        isLoadingRoutes = false
        // 重新导航到目标路由（replace 避免在历史记录中留下痕迹）
        next({ ...to, replace: true })
      } catch (error) {
        console.error('加载路由失败:', error)
        isLoadingRoutes = false
        // 加载失败时继续导航，可能会显示404或默认页面
        next()
      }
    } else {
      // 路由已加载且目标路由存在，直接放行
      next()
    }
  })
}

export default router
